import Vue from "vue";
import VueRouter from "vue-router";
import Dashboard from "../views/dashboard/Dashboard.vue";
import Channelauditmanagement from "./modules/channelaudit";
import Createaccountmanagement from "./modules/createaccount";
import informationentrymanagement from "./modules/informationentry";
import advertisementmanagement from "./modules/advertisement";
import abnormaldetails from "./modules/abnormaldetails";
import operationlog from "./modules/operationlog";
import noipcusermanagement from "./modules/noipcuser";
import errorcodemanagement from "./modules/errorcode";
import propetty from "./modules/propertyment";
Vue.use(VueRouter);

// 路由点击两次报错解决
const routerPush = VueRouter.prototype.push;
VueRouter.prototype.push = function push(location) {
  return routerPush.call(this, location).catch(error => error);
};

export const constantRoutes = [
  // {
  //   path: "/equmentdetalis",
  //   redirect: "equment",
  //   component: Dashboard,
  //   children: [
  {
    path: "/e",
    name: "e",
    component: () => import("../components/equment/index.vue"),
    meta: {
      title: "说明文档",
      icon: "el-icon-s-home",
      role: false
    }
  },
  //   ]
  // },
  {
    path: "/",
    name: "homename",
    redirect: "home",
    component: Dashboard,
    children: [
      {
        path: "/home",
        name: "home",
        component: () => import("../components/home/index.vue"),
        meta: {
          title: "首页",
          icon: "el-icon-s-home",
          role: false
        }
      }
    ]
  },
  Channelauditmanagement,
  Createaccountmanagement,
  informationentrymanagement,
  propetty,
  advertisementmanagement,
  abnormaldetails,
  operationlog,
  noipcusermanagement,
  errorcodemanagement
];
export const asyncRoutes = []; //动态路由

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes: constantRoutes //固定路由
});

export default router;
